import styled from "styled-components";

import {
  COLORS,
  FONTS,
  FONT_SIZE,
  CARD_BACKGROUND,
} from "../../../constants/Styles";

export const AddMoreFiles = styled.div`
  margin-top: 1rem;
  border-radius: 1rem;
  border: 1px dashed ${COLORS.secondaryLight};
  color: ${COLORS.secondaryLight};
  ${CARD_BACKGROUND};
  cursor: pointer;
  padding: 1rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const FILE_INPUT_WIDTH = "332px";

export const Container = styled.label<{
  hasFile: boolean;
  disabled?: boolean;
  width?: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${({ width }) => width || FILE_INPUT_WIDTH};
  min-height: 288px;
  padding: 5rem 2rem 3rem 2rem;
  border-radius: 1rem;
  border: 1px dashed ${COLORS.secondaryLight};
  color: ${COLORS.secondaryLight};
  box-shadow: 0 0.25rem 0.25rem 0 rgba(0, 0, 0, 0.25);

  ${CARD_BACKGROUND};

  @media (max-width: 500px) {
    width: ${({ width }) => width || "100%"};
  }

  ${({ hasFile }) =>
    hasFile &&
    `
    background-color: ${COLORS.black};
    border: none;
    color: ${COLORS.secondary};
  `}

  ${({ disabled, hasFile }) => (!disabled || !hasFile) && `cursor: pointer;`}
  ${({ disabled }) => disabled && `filter: brightness(50%);`}
`;

export const Label = styled.div<{ mini?: boolean }>`
  text-align: center;
  font-size: ${FONT_SIZE.size24};
  font-family: ${FONTS.spaceGrotesk};
  margin-top: 1rem;
  overflow-wrap: break-word;
`;

export const FileListItems = styled.div<{ hasMultiple: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-wrap: wrap;
  align-content: ${({ hasMultiple }) =>
    hasMultiple ? "flex-start" : "center"};
`;

export const FileListItem = styled.div<{ addSeparator: boolean }>`
  display: flex;
  margin: 0.5rem;
  ${({ addSeparator }) =>
    addSeparator
      ? `
    border-bottom: 1px solid ${COLORS.inputGray};
    width: 100%;
    `
      : ""}
  padding-bottom: 1rem;
`;

export const FileListName = styled.div<{ smallText: boolean }>`
  text-align: left;
  font-size: ${({ smallText }) =>
    smallText ? FONT_SIZE.size12 : FONT_SIZE.size16};
  font-family: ${FONTS.spaceGrotesk};
  overflow-wrap: anywhere;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
`;
